import React from 'react'
import type { FocusPosition } from '@tiptap/react'
import { Editor } from '@paintscout/ui-business'
import type { StyleClasses } from '@paintscout/ui'
import type { EditorMethods } from '@paintscout/ui-business'

export interface HtmlEditorProps {
  autofocus?: FocusPosition
  classes?: StyleClasses<any>
  hasColor?: boolean
  header?: boolean
  onChange?: (content: string) => void
  presetColors?: string[]
  tippyOptions?: any
  value?: string
  disableToolbar?: boolean
}

const HtmlEditor = React.forwardRef(function HtmlEditor(
  props: HtmlEditorProps,
  ref: React.ForwardedRef<EditorMethods>
) {
  const { autofocus, classes, hasColor, header = true, onChange, value, disableToolbar } = props

  return (
    <Editor
      ref={ref}
      autofocus={autofocus}
      classes={classes}
      content={value || ''}
      debounce={false}
      bubbleMenuEnabled
      floatingMenuEnabled
      disableToolbar={disableToolbar}
      onChange={onChange}
      toolbar={{
        bold: true,
        italic: true,
        underline: true,
        color: hasColor,
        headings: header,
        lists: true,
        align: true,
        link: true
      }}
    />
  )
})

export default HtmlEditor
